import React from 'react';
import PropTypes from 'prop-types';
import { animated, useSpring } from "react-spring";
import { CircularProgress, styles, Typography } from '../index';
import Backdrop from './Backdrop.jsx';

const Loading = (props) => {
  const classes = useStyles(props);
  const theme = styles.useTheme();
  const [ reverse, setReverse ] = React.useState(false);

  const textStyle = useSpring({
    to: { opacity: 1, color: theme.palette.primary.main },
    from: { opacity: 0.5, color: theme.palette.primary.main },
    reset: reverse,
    reverse,
    duration: 10000
  });

  // if (!props.loading) return null;
  return (
    <Backdrop
      className={classes.root}
      open={props.loading}
      data-testid={props['data-testid']}>
      <CircularProgress variant={'indeterminate'} color={'inherit'} />
      {
        !!props.loadingText && (
          <animated.div className={classes.text} style={textStyle}>
            <Typography variant={'caption'}>{ props.loadingText }</Typography>
          </animated.div>
        )
      }
    </Backdrop>
  );
};

Loading.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string,
};

const useStyles = styles.makeStyles(
  theme => ({
    root: props => ({
      zIndex: theme.zIndex.drawer + 1,
      color: props.color || 'white',
    }),
    text: {
      marginTop: theme.spacing(2),
    }
  })
)

export default Loading;
